import { atomWithStorage } from 'jotai/utils';
import { makeJotaiSessionStorage } from './createSessionStorage';
import { SyncStorage } from 'jotai/vanilla/utils/atomWithStorage';

const localStorageKey = 'companyId';

const companyIdxAtom = atomWithStorage(
  localStorageKey,
  0,
  makeJotaiSessionStorage() as SyncStorage<number>
);

export default companyIdxAtom;
